define('i18n',[], function () {
    "use strict";

    var catalog = {};
    var catalogElement = document.querySelector("meta[name='vegzone-ui-localization']");
    var cultureElement = document.querySelector("meta[name='vegzone-ui-culture']");
    var countryElement = document.querySelector("meta[name='vegzone-ui-country']");
    var routesElement = document.querySelector("meta[name='vegzone-ui-routes']");
    var routeCatalog = {};

    if (catalogElement) {
        try {
            catalog = JSON.parse(catalogElement.getAttribute("content") || "{}");
        } catch (error) {
            if (window.console) console.error("Could not parse the UI localization catalog.", error);
        }
    }

    if (routesElement) {
        try {
            routeCatalog = JSON.parse(routesElement.getAttribute("content") || "{}");
        } catch (error) {
            if (window.console) console.error("Could not parse the localized route catalog.", error);
        }
    }

    function format(value, values) {
        if (!values) return value;

        return value.replace(/\{([^{}]+)\}/g, function (match, name) {
            var replacement = Array.isArray(values) ? values[Number(name)] : values[name];
            return replacement === undefined || replacement === null ? match : replacement;
        });
    }

    function t(key, values) {
        return format(Object.prototype.hasOwnProperty.call(catalog, key) ? catalog[key] : key, values);
    }

    function localizeTemplate(html) {
        return html.replace(/\{\{t:([A-Za-z0-9_.-]+)\}\}/g, function (_, key) {
            return t(key);
        });
    }

    function appendRoute(root, segment) {
        return root.replace(/\/$/, "") + "/" + encodeURIComponent(segment);
    }

    var routes = {
        placesRoot: routeCatalog.placesRoot || "/mista",
        allPlaces: routeCatalog.allPlaces || "/mista/vse",
        createVenue: routeCatalog.createVenue || "/mista/vytvorit",
        profilesRoot: routeCatalog.profilesRoot || "/profily",
        pagesRoot: routeCatalog.pagesRoot || "/p",
        vegboardRoot: routeCatalog.vegboardRoot || "/vegboard",
        feedRoot: routeCatalog.feedRoot || "/feed",
        accountRoot: routeCatalog.accountRoot || "/account",
        accountCheckins: routeCatalog.accountCheckins || "/account/checkins",
        accountWishlist: routeCatalog.accountWishlist || "/account/wishlist",
        accountFavourites: routeCatalog.accountFavourites || "/account/favourites",
        accountSettings: routeCatalog.accountSettings || "/account/settings",
        accountPassword: routeCatalog.accountPassword || "/account/password",
        accountOwners: routeCatalog.accountOwners || "/account/owners",
        accountDelete: routeCatalog.accountDelete || "/account/delete",
        accountActivation: routeCatalog.accountActivation || "/account/activation",
        login: routeCatalog.login || "/login",
        registration: routeCatalog.registration || "/registration",
        createPassword: routeCatalog.createPassword || "/create-password",
        logout: routeCatalog.logout || "/logout",
        invitation: routeCatalog.invitation || "/invitation"
    };
    routes.profile = function (id) {
        return appendRoute(routes.profilesRoot, id);
    };
    routes.page = function (slug) {
        return appendRoute(routes.pagesRoot, slug);
    };

    var i18n = {
        locale: cultureElement ? cultureElement.getAttribute("content") : (document.documentElement.lang || "cs"),
        country: countryElement ? countryElement.getAttribute("content") : "CZ",
        t: t,
        localizeTemplate: localizeTemplate,
        routes: routes
    };

    try {
        window.localStorage.setItem("vz-language", i18n.locale.split(/[-_]/)[0]);
    } catch (ignored) {
    }

    window.vzI18n = i18n;
    return i18n;
});

